import(/* webpackMode: "eager", webpackExports: ["ByoidProvider"] */ "/app/src/app/_components/NDR/ByoidProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExtentedReviewsWrapper"] */ "/app/src/app/_components/NDR/Wrappers/ExtentedReviewsWrapper.tsx");
